module.exports = __webpack_public_path__ + "static/mo14-6d5d9d956670f34f27910e6dee0234a7.png";